import { createFileRoute } from '@tanstack/react-router';

import { AnnouncementsPage } from '@/features/admin/AnnouncementsPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/announcements')({
  beforeLoad: () => requireRouteAccess('/admin/announcements'),
  component: AnnouncementsPage,
});
